// src/components/assistant/ProviderLogo.tsx
//
// Marca de cada proveedor del selector de modelos. Monograma (no el logotipo):
// así no se redibuja ni se altera ninguna marca registrada. Si se aprueban los
// SVG oficiales, van aquí sin modificar (un archivo por proveedor) y el resto
// del selector no cambia.

const MONO: Record<string, { letter: string; name: string }> = {
  openai: { letter: 'O', name: 'OpenAI' },
  anthropic: { letter: 'A', name: 'Anthropic' },
  xai: { letter: 'X', name: 'Grok (xAI)' },
  google: { letter: 'G', name: 'Gemini (Google)' },
  totbi: { letter: 'U', name: 'U-CogNet' },
};

export function providerName(provider: string): string {
  return MONO[provider]?.name ?? provider;
}

export function ProviderLogo({ provider, size = 18, muted = false }: { provider: string; size?: number; muted?: boolean }) {
  const m = MONO[provider] ?? { letter: (provider || '?').slice(0, 1).toUpperCase(), name: provider };
  return (
    <span
      aria-hidden
      title={m.name}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.55) }}
      className={`inline-flex shrink-0 items-center justify-center rounded-[5px] font-semibold leading-none ${
        muted ? 'bg-muted text-muted-foreground' : 'bg-foreground text-background'
      }`}
    >
      {m.letter}
    </span>
  );
}
